export const SET_SUMMARY = "adminBooking/SET_SUMMARY";
export const SET_DAY = "adminBooking/SET_DAY";
export const SET_FILTERS = "adminBooking/SET_FILTERS";
export const SET_LIST = "adminBooking/SET_LIST";
export const SET_BOOKING = "adminBooking/SET_BOOKING";
export const UPDATE_IN_DAY = "adminBooking/UPDATE_IN_DAY";
export const SET_SETTINGS = "adminBooking/SET_SETTINGS";
export const SET_SPECIAL_DATES = "adminBooking/SET_SPECIAL_DATES";
export const SET_USERS = "adminBooking/SET_USERS";
